'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconInactive = function IconInactive(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement('path', {
            d: 'M9.735 14.099V5.422a.687.687 0 0 0-.682-.692.687.687 0 0 0-.681.692v8.677c0 .382.305.692.681.692.377 0 .682-.31.682-.692zm-3.107 0V5.422a.687.687 0 0 0-.682-.692.687.687 0 0 0-.681.692v8.677c0 .382.305.692.681.692.377 0 .682-.31.682-.692zm6.16-9.37a.687.687 0 0 0-.681.693v10.48c0 .28-.225.51-.501.51H3.395a.507.507 0 0 1-.502-.51V5.422a.687.687 0 0 0-.682-.692.687.687 0 0 0-.682.692v10.48c0 1.044.837 1.894 1.866 1.894h8.21c1.029 0 1.865-.85 1.865-1.894V5.422a.687.687 0 0 0-.681-.692zm1.514-2.156h-3.087V.897a.687.687 0 0 0-.681-.693H4.466a.687.687 0 0 0-.681.693v1.676H.698a.687.687 0 0 0-.682.692c0 .382.305.692.682.692h13.604c.377 0 .682-.31.682-.692a.687.687 0 0 0-.682-.692zm-4.45 0H5.148v-.984h4.704v.984z',
            fill: '#3F5060',
            fillRule: 'evenodd'
        })
    );
};

IconInactive.defaultProps = {
    width: '15',
    height: '18',
    viewBox: '0 0 15 18',
    xmlns: 'http://www.w3.org/2000/svg'
};

var IconHover = function IconHover(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement('path', {
            d: 'M9.735 14.099V5.422a.687.687 0 0 0-.682-.692.687.687 0 0 0-.681.692v8.677c0 .382.305.692.681.692.377 0 .682-.31.682-.692zm-3.107 0V5.422a.687.687 0 0 0-.682-.692.687.687 0 0 0-.681.692v8.677c0 .382.305.692.681.692.377 0 .682-.31.682-.692zm6.16-9.37a.687.687 0 0 0-.681.693v10.48c0 .28-.225.51-.501.51H3.395a.507.507 0 0 1-.502-.51V5.422a.687.687 0 0 0-.682-.692.687.687 0 0 0-.682.692v10.48c0 1.044.837 1.894 1.866 1.894h8.21c1.029 0 1.865-.85 1.865-1.894V5.422a.687.687 0 0 0-.681-.692zm1.514-2.156h-3.087V.897a.687.687 0 0 0-.681-.693H4.466a.687.687 0 0 0-.681.693v1.676H.698a.687.687 0 0 0-.682.692c0 .382.305.692.682.692h13.604c.377 0 .682-.31.682-.692a.687.687 0 0 0-.682-.692zm-4.45 0H5.148v-.984h4.704v.984z',
            fill: '#A7F2EB',
            fillRule: 'evenodd'
        })
    );
};

IconHover.defaultProps = {
    width: '15',
    height: '18',
    viewBox: '0 0 15 18',
    xmlns: 'http://www.w3.org/2000/svg'
};

var IconDisabled = function IconDisabled(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement('path', {
            d: 'M9.735 14.099V5.422a.687.687 0 0 0-.682-.692.687.687 0 0 0-.681.692v8.677c0 .382.305.692.681.692.377 0 .682-.31.682-.692zm-3.107 0V5.422a.687.687 0 0 0-.682-.692.687.687 0 0 0-.681.692v8.677c0 .382.305.692.681.692.377 0 .682-.31.682-.692zm6.16-9.37a.687.687 0 0 0-.681.693v10.48c0 .28-.225.51-.501.51H3.395a.507.507 0 0 1-.502-.51V5.422a.687.687 0 0 0-.682-.692.687.687 0 0 0-.682.692v10.48c0 1.044.837 1.894 1.866 1.894h8.21c1.029 0 1.865-.85 1.865-1.894V5.422a.687.687 0 0 0-.681-.692zm1.514-2.156h-3.087V.897a.687.687 0 0 0-.681-.693H4.466a.687.687 0 0 0-.681.693v1.676H.698a.687.687 0 0 0-.682.692c0 .382.305.692.682.692h13.604c.377 0 .682-.31.682-.692a.687.687 0 0 0-.682-.692zm-4.45 0H5.148v-.984h4.704v.984z',
            fill: '#E4E6E8',
            fillRule: 'evenodd'
        })
    );
};

IconDisabled.defaultProps = {
    width: '15',
    height: '18',
    viewBox: '0 0 15 18',
    xmlns: 'http://www.w3.org/2000/svg'
};

var Delete = function (_React$Component) {
    _inherits(Delete, _React$Component);

    function Delete() {
        _classCallCheck(this, Delete);

        return _possibleConstructorReturn(this, (Delete.__proto__ || Object.getPrototypeOf(Delete)).apply(this, arguments));
    }

    _createClass(Delete, [{
        key: 'render',
        value: function render() {
            if (this.props.disabled) return _react2.default.createElement(IconDisabled, null);
            if (this.props.hover) return _react2.default.createElement(IconHover, null);
            return _react2.default.createElement(IconInactive, null);
        }
    }]);

    return Delete;
}(_react2.default.Component);

exports.default = Delete;